var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.pointsClasses }, [
    _vm._v(
      "\n  " +
        _vm._s(_vm._f("price")(Math.abs(_vm.value))) +
        " " +
        _vm._s(_vm._f("decl")(_vm.value, "бонус", ["", "а", "ов"])) +
        "\n"
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }